import styled from "styled-components";

export const ActionButtonContainer = styled.div<{ isOpen: boolean}>`
    position: fixed; 
    top: 20px;
    right: ${props => props.isOpen ? '20px' : '-200px'};
    bottom: 20px;
    width: 180px; 
    display: flex;
    flex-direction: column;
    will-change: transform; 
    transform: translateZ(0);
    background: rgba(12, 5, 5, 0.8);
    border-radius: 8px;
    padding: 16px;
    overflow-y: auto;
    transition: right 0.3s ease; 
    z-index: 1000;
    gap: 8px;
`